<template>
  <a-spin :spinning="pageloading">
    <a-card class="m-display-flex flex-column nowrap">
      <span slot="title">Create Invoice</span>

      <!-- <a-form class="margin-bottom" :form="form">
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
              
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
              
            </a-col>
          </a-row>
        </a-form> -->
      <a-steps :current="current" status="process">
        <a-step title="Information" />
        <a-step title="Detail Deliverable" />
        <a-step title="Detail PPN" />
      </a-steps>
      <div class="steps-content flex-1">
        <keep-alive>
          <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
        </keep-alive>
      </div>

      <!-- <template class="ant-card-actions" slot="actions">
        <div class="steps-action">
          <a-button
            class="padding-remove"
            type="primary"
            @click="save"
            :loading="pageloading"
            >save</a-button
          >
          <a-button @click="preview" :loading="previewLoad"
            >Preview Invoice</a-button
          >
        </div>
      </template> -->
      <template class="ant-card-actions" slot="actions">
        <div class="steps-action">
          <a-button v-if="current < steps.length - 1" type="primary" @click="next" :disabled="pageLaoding">Next</a-button>
          <a-button-group v-if="current == steps.length - 1">
            <a-button @click="preview" :loading="previewLoad" :icon="getScreen ? 'eye' : ''">
              {{ getScreen ? "" : "Preview Invoice" }}
            </a-button>
            <a-button :loading="btnLoading" :disabled="pageLaoding" type="primary" @click="validate">Save</a-button>
          </a-button-group>
          <a-button v-if="current > 0" @click="prev" :icon="getScreen ? 'arrow-left' : ''">{{ getScreen ? "" : "Previous"
          }}</a-button>
        </div>
      </template>
    </a-card>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import _ from "lodash";

import Informasi from "./steps_v2/Informasi.vue";
import DetailPPN from "./steps_v2/DetailPPN.vue";
import DetailDeliverable from "./steps_v2/ProductDetail.vue";

export default {
  name: "CreateARNGeneral",
  props: ["id", "type"],
  mixins: [CurrencyFormat],
  components: {
    Informasi,
    DetailPPN,
    DetailDeliverable,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Detail Deliverable",
          content: "DetailDeliverable",
        },
        {
          title: "Detail PPN",
          content: "DetailPPN",
        },
      ],
      mode: "Create",
      postData: new FormData(),
      push: [],
      collectData: {
        information: null,
        detil_product: [],
      },
      pageloading: false,
      previewLoad: false,
      bankAccount: [],
      bankAccountStatus: false,
      bank: "",

      pageLaoding: false,
      btnLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getScreen",
    ]),
    stepProps: function () {
      let result = {};
      if (this.steps[this.current].content === "Informasi") {
        result = {
          id: this.id,
          information: this.collectData.information,
          // combo_pimpro : this.collectData.combo_pimpro,
        };
      } else if (this.steps[this.current].content === "DetailDeliverable") {
        result = {
          id: this.id,
          information: this.collectData.information,
          detil_product: this.collectData.detil_product,
          detil_termin_list: this.collectData.detil_termin_list,
          mode: this.mode,
          currency: this.collectData.information.currency,
        };
      } else if (this.steps[this.current].content === "DetailPPN") {
        result = {
          collectData: this.collectData
        };
      }
      return result;
    },
    stepRef: function () {
      let val = "";
      if (this.steps[this.current].content === "Informasi") {
        val = "refInformasi";
      } else if (this.steps[this.current].content === "DetailDeliverable") {
        val = "refDetailDeliverable";
      } else if (this.steps[this.current].content === "DetailPPN") {
        val = "refDetailPPN";
      }
      return val;
    },
  },
  methods: {
    moment,
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "DetailDeliverable") {
        this.$refs.refDetailDeliverable.handleRef();
      }
    },
    setSubmitForm() {
      this.postData = new FormData();
      this.postData.append("id", this.id == "_" ? this.collectData.SC.id : this.id);
      this.postData.append("tlc", this.getAuth.username);
      this.postData.append(
        "upload_file_support",
        this.collectData.information.upload.file
      );
      this.postData.append("efaktur", this.collectData.information.invoice_no);
      this.postData.append("customer", this.collectData.information.customer);
      this.postData.append(
        "bank_account_id",
        this.collectData.information.bank_account_id
      );
      this.postData.append(
        "invoice_date",
        moment(this.collectData.information.invoice_date).format(
          this.getStandartFormatDate
        )
      );
      this.postData.append(
        "exchange_rate", this.collectData.information.exchange_rate
      );

      // this.postData.append("ppn_sktd", this.collectData.detil_invoice.ppn_sktd);
      // this.postData.append(
      //   "ppn_dipungut",
      //   this.collectData.detil_invoice.ppn_dipungut
      // );
      // this.postData.append(
      //   "ppn_memungut",
      //   this.collectData.detil_invoice.ppn_memungut
      // );
      // this.postData.append(
      //   "ppn_migas",
      //   this.collectData.detil_invoice.ppn_migas
      // );

      this.postData.append("type_ppn", this.collectData.detil_invoice.type_ppn);
      if (this.collectData.detil_invoice.value_tax)
        this.postData.append("value_tax", this.collectData.detil_invoice.value_tax);
      if (this.collectData.detil_invoice.push)
        this.postData.append("upload_document_tax", this.collectData.detil_invoice.push);

      this.collectData.detil_product.forEach((data, index) => {
        this.postData.append(
          `detil_product[${index}][produk_name]`,
          data.product_nm
        );
        this.postData.append(`detil_product[${index}][id_sc_dtl_invoice]`, data.termin_release_dtl_id);
        this.postData.append(`detil_product[${index}][pn]`, data.product_pn);
        this.postData.append(`detil_product[${index}][note]`, data.note);
        //this.postData.append(`detil_product[${index}][unit]`, data.unit);
        this.postData.append(`detil_product[${index}][qty]`, data.qty);
        this.postData.append(
          `detil_product[${index}][unit_price]`,
          data.unit_price
        );
      });
      //this.postData.append("pph22", this.collectData.detil_invoice.pph22_15);
      //this.postData.append("fee_lain", this.collectData.detil_invoice.fee_lain);
      //this.postData.append("taktis", this.collectData.detil_invoice.taktis);
    },
    submit() {
      this.setSubmitForm();
      let method = "";
      let data = "";
      let url = "";

      method = "post";
      data = this.postData;
      url = this.$serviceUrl + "akuntansi/ar_akuntansi/create_ar_acc";

      this.pageloading = true;
      axios({
        method: method,
        url: url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (this.mode === "Create") {
            this.displayMessage("success-save");
          } else {
            this.displayMessage("success-edit");
          }
          this.pageloading = false;
          this.$router.push({ name: "arAccounting-index" });
        })
        .catch((err) => {
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            //console.log(responses);
            this.displayMessageValue("error", responses);
          }
          this.pageloading = false;
        });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handleRemove() {
      this.push = [];
    },
    validate() {
      this.$refs.refDetailPPN.handleRef();
    },
    prev() {
      this.current--;
    },
    preview() {
      this.previewLoad = true;
      this.$refs.refDetailPPN.handleRef();
      if (this.collectData.detil_invoice == undefined) {
        this.previewLoad = false;
        return
      }
      let ar_value = _.sumBy(this.collectData.detil_product, function (val) {
        return Number(val.total_price) * Number(val.qty)
      });
      axios({
        method: "get",
        url: this.$serviceUrl + "account_receivable/cetak_AR",
        params: {
          id: this.id,
          bank_account_id: this.collectData.information.bank_account_id,
          type_ppn: this.collectData.detil_invoice.type_ppn,
          value_tax: this.collectData.detil_invoice.value_tax,
          dtl: this.collectData.detil_product,

          efaktur_no: this.collectData.information.efaktur,
          ar_value: ar_value,
          date_invoice: moment(this.collectData.information.invoice_date).format('YYYY-MM-DD'),
        },
        responseType: "blob",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.previewLoad = false;
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        })
        .catch((err) => {
          if (err.response && err.response.status === 404) {
            this.displayMessage("404");
          } else if (err.response) {
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
          }
          this.previewLoad = false;
          this.$router.go(-1);
        });
    },
    valueFromChild(value) {
      if (this.previewLoad) {
        this.collectData.detil_invoice = value.detil_invoice;
        return;
      }

      if (this.steps[this.current].content === "Informasi") {
        this.collectData.information = value.values;
        this.collectData.detil_product = value.deliverable;
        this.collectData.detil_termin_list = value.termin_dtl;
        this.collectData.SC = value.SC;
        this.current++;
      } else if (this.steps[this.current].content === "DetailDeliverable") {
        this.collectData.detil_product = value.detil_product;
        this.current++;
      } else if (this.steps[this.current].content === "DetailPPN") {
        this.collectData.detil_invoice = value.detil_invoice;
        this.confirmMessage("confirm-save");
      }
    },
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.submit);
    Event.$on("emitChild", this.valueFromChild);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.submit);
    Event.$off("emitChild", this.valueFromChild);
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style></style>
